import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavLink, NavSection } from '../shell/nav-menu';
import { SettingsMenuService } from './settings-menu.service';

/**
 * Settings workspace (mockup settings): wraps the page outlet. On a settings page it adds the
 * settings list on the left (groups, search, "Back to dashboard"); everywhere else it is just
 * the page. Settings pages keep their own URLs (/office-fees, /codes-list ...), so links and
 * bookmarks to them are unchanged.
 */
@Component({
    selector: 'app-settings-workspace',
    templateUrl: './settings-workspace.component.html',
    styleUrls: ['./settings-workspace.component.scss']
})
export class SettingsWorkspaceComponent implements OnInit, OnDestroy {
    sections: NavSection[] = [];
    active = false;
    activeLink: NavLink = null;
    open: { [title: string]: boolean } = {};
    search = '';
    private url = '';
    private subscriptions: Subscription[] = [];

    constructor(private menu: SettingsMenuService, private router: Router) { }

    ngOnInit() {
        this.url = this.router.url;
        this.subscriptions.push(this.menu.sections$.subscribe(sections => {
            this.sections = sections;
            this.refresh();
        }));
        this.subscriptions.push(this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
            this.url = e.urlAfterRedirects;
            this.search = '';
            this.refresh();
        }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    private refresh() {
        const page = SettingsMenuService.find(this.sections, this.url);
        this.activeLink = page ? page.link : null;
        this.active = !!page || SettingsMenuService.isWorkspaceUrl(this.url);
        if (page) {
            this.open[page.group] = true;   // the open page's group stays expanded
            if (page.link.route) {
                SettingsMenuService.remember(page.link.route);
            }
        }
    }

    toggle(section: NavSection) {
        this.open[section.title] = !this.open[section.title];
    }

    get results(): { link: NavLink, group: string }[] {
        const q = this.search.trim().toLowerCase();
        const out = [];
        this.sections.forEach(s => s.links.forEach(link => {
            if ((link.label + ' ' + s.title + ' ' + (link.description || '')).toLowerCase().indexOf(q) !== -1) {
                out.push({ link, group: s.title });
            }
        }));
        return out;
    }
}
